import { createStyles } from '@mantine/core';

export const usePricingInfoModalStyles = createStyles((theme) => ({
  button: {
    marginTop: theme.other.spacing._24,
  },
  iframeContainer: {
    marginTop: theme.other.spacing._16,
    marginBottom: theme.other.spacing._16,
    borderRadius: theme.other.spacing._8,
    overflow: 'hidden',
    position: 'relative',
    height: 456,
  },
  iframe: {
    width: '100%',
    height: 456,
    border: 'none',
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.other.spacing._8,
  },
}));
